export default function DietaryMark({ dietaryType, testId }) {
  if (dietaryType !== "veg" && dietaryType !== "non-veg") {
    return null;
  }

  const isVeg = dietaryType === "veg";
  const label = isVeg ? "Vegetarian" : "Non-vegetarian — Contains Egg";
  const color = isVeg ? "#0F8A5F" : "#8B261D";

  return (
    <span
      aria-label={label}
      title={label}
      data-testid={testId}
      className="inline-flex h-4 w-4 shrink-0 items-center justify-center border"
      style={{ borderColor: color }}
    >
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
    </span>
  );
}